import { render } from "./sideNav.vue?vue&type=template&id=4b124e7e&scoped=true"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"

import "./sideNav.vue?vue&type=style&index=0&id=4b124e7e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Livio\\Desktop\\DIploma\\ITSA\\itsa-vue\\ITSA-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b124e7e"]])

export default __exports__